import { Button } from '@material-ui/core'
import {
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { a11yProps, Tab, Tabs } from 'asterX-UI/Tabs'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import HeaderBack from 'components/Mobile/HeaderBack'
import { useResErrors } from 'hooks'
import { SalesService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import moment from 'moment/moment'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  total: {
    display: 'flex',
    gap: 12,
    fontWeight: 600,
    fontSize: 14
  },
  totalText: {
    color: GRAY_COLORS['400']
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  opened: {
    display: 'flex',
    gap: 12,
    fontWeight: 400,
    fontSize: 14
  },
  openedText: {
    color: WARNING_COLORS['500']
  },
  closed: {
    display: 'flex',
    gap: 12,
    fontWeight: 400,
    fontSize: 14,
    marginRight: 18
  },
  closedText: {
    color: SUCCESS_COLORS['600']
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  card: {
    padding: '24px 16px',
    backgroundColor: '#fff',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  rowTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  cardTitle: {
    fontSize: 16,
    fontWeight: 600
  },
  cardDate: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS['500']
  },
  rowInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 5
  },
  infoBlock: {
    width: '50%'
  },
  infoHeading: {
    color: GRAY_COLORS['400'],
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 5
  },
  cardTotal: {
    display: 'flex',
    gap: 10,
    fontSize: 14,
    fontWeight: 500,
    marginTop: 8
  },
  cardTotalName: {
    color: GRAY_COLORS['400']
  },
  cardTotalAmount: {
    color: GRAY_COLORS['700']
  },
  infoText: {
    color: GRAY_COLORS['700'],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px'
  }
}))
const OrdersModal = ({ onClose, vin }) => {
  const classes = useStyles()
  const { standardCheck } = useResErrors()
  const [tab, setTab] = useState('open')
  const [loading, setLoading] = useState(false)
  const [workOrders, setWorkOrders] = useState({
    total: 0,
    closedTotal: 0,
    openTotal: 0,
    open: [],
    closed: []
  })
  useEffect(() => {
    getWorkOrdersByVin()
  }, [])
  const ordersTabs = [
    { label: 'Закрытые', value: 'closed' },
    { label: 'Открытые', value: 'open' }
  ]

  const getWorkOrdersByVin = async () => {
    setLoading(true)
    await SalesService.getWorkOrdersByVin(vin).then(res =>
      standardCheck(res, () => {
        const filteredOrders = res.data?.reduce(
          (acc, cur) => {
            const totalWoAmount = cur.totalWoAmount?.toString()?.toNum() || 0
            const isClosed = cur.woState === 'Закрыт'

            return {
              total: acc.total + totalWoAmount,
              closedTotal: acc.closedTotal + (isClosed ? totalWoAmount : 0),
              openTotal: acc.openTotal + (!isClosed ? totalWoAmount : 0),
              open: !isClosed ? [...acc.open, cur] : acc.open,
              closed: isClosed ? [...acc.closed, cur] : acc.closed
            }
          },
          {
            total: 0,
            closedTotal: 0,
            openTotal: 0,
            open: [],
            closed: []
          }
        )
        setWorkOrders(filteredOrders)
      })
    )
    setLoading(false)
  }

  return (
    <PageContainerMobile
      customHeader={<HeaderBack onClick={onClose}>Заказ-наряды</HeaderBack>}
      style={{
        backgroundColor: '#FAFAFA',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        position: 'relative'
      }}
    >
      <LoaderBackdrop loading={loading} />
      <div className={classes.summary}>
        <div className={classes.total}>
          <div className={classes.totalText}>Итого:</div>
          <div className={classes.totalAmount}>
            {workOrders?.total?.toString()?.thousandSeparator() || '-'} ₸{' '}
          </div>
        </div>
        <div className={classes.summaryRow}>
          <div className={classes.opened}>
            <div className={classes.openedText}>Открытые:</div>
            <div className={classes.openedAmount}>
              {workOrders?.openTotal?.toString()?.thousandSeparator() || '-'} ₸{' '}
            </div>
          </div>
          <div className={classes.closed}>
            <div className={classes.closedText}>Закрытые:</div>
            <div className={classes.closedAmount}>
              {workOrders?.closedTotal?.toString()?.thousandSeparator() || '-'}{' '}
              ₸
            </div>
          </div>
        </div>
      </div>
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        value={tab}
        onChange={(e, value) => setTab(value)}
      >
        {ordersTabs.map((tab, index) => (
          <Tab
            label={tab.label}
            {...a11yProps(tab.value)}
            value={tab.value}
            key={`tab_${index}`}
          />
        ))}
      </Tabs>
      <div className={classes.cardContainer}>
        {workOrders[tab]?.map(v => (
          <Card key={`Wo_${v?.id}`} workOrder={v} />
        ))}
      </div>
      <Button
        variant={'contained'}
        color={'primary'}
        fullWidth
        size={'small'}
        onClick={onClose}
      >
        Закрыть
      </Button>
    </PageContainerMobile>
  )
}

export default OrdersModal

const Card = ({ workOrder }) => {
  const classes = useStyles()
  return (
    <div className={classes.card}>
      <div className={classes.rowTitle}>
        <div className={classes.cardTitle}> {workOrder.woNum}</div>
        <div className={classes.cardDate}>
          {' '}
          {workOrder.woDate
            ? moment(workOrder.woDate, 'DD.MM.YYYY H:mm:ss').format(
                'DD.MM.YYYY'
              )
            : ''}
        </div>
      </div>
      <ChipStandard
        color={PRIMARY_COLORS[700]}
        backgroundColor={PRIMARY_COLORS[50]}
      >
        {(workOrder.repairType || '') +
          ' / ' +
          (workOrder?.repairSubtype || '')}
      </ChipStandard>
      <div className={classes.rowInfo}>
        <InfoBlock label={'Место'} value={workOrder.department} />
        <InfoBlock
          label={'Открыт'}
          value={[workOrder.openDate, workOrder.openTime]
            .filter(e => !!e)
            .join(' ')}
        />
      </div>
      <div className={classes.rowInfo}>
        <InfoBlock label={'Описание'} value={workOrder.defects} />
        <InfoBlock
          label={'Закрыт'}
          value={[workOrder.closeDate, workOrder.closeTime]
            .filter(e => !!e)
            .join(' ')}
        />
      </div>
      <div className={classes.cardTotal}>
        <div className={classes.cardTotalName}>Итого:</div>
        <div className={classes.cardTotalAmount}>
          {' '}
          {workOrder.totalWoAmount || 0} ₸
        </div>
      </div>
    </div>
  )
}

const InfoBlock = ({ label, value }) => {
  const classes = useStyles()

  return (
    <div className={classes.infoBlock}>
      <div className={classes.infoHeading}>{label}</div>
      <div className={classes.infoText}>{value}</div>
    </div>
  )
}
